import { Users } from "lucide-react";
import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

import "@/styles/task-kind.css";

/** Small "Interna" pill marking a team task (no contact). */
export const TaskKindBadge = ({ className }: { className?: string }) => {
  const translate = useTranslate();
  return (
    <span className={cn("task-kind-badge", className)}>
      <Users aria-hidden />
      {translate("resources.tasks.kind.internal")}
    </span>
  );
};
